<template>
	<div>
		<label :for="question.Key">
			{{ question.Value.Description }}
			<i v-if="question.Value.Required">*</i>

			<info-text :info-text="question.Value.ToolTipText"></info-text>

			<br />
			<input
				v-if="question.Value.Type === 'Date'"
				@change="emitChange"
				:type="inputType"
				:id="question.Key"
				:disabled="question.Value.Disabled"
				placeholder="DD-MM-JJJJ"
				v-mask="['##-##-####']"
				required
				v-model="question.Value.UserValue"
			/>
			<input
				@change="emitChange"
				v-else-if="question.Key && question.Key.indexOf('PostalCode') > -1"
				:type="inputType"
				:disabled="question.Value.Disabled"
				:id="question.Key"
				v-mask="['####AA']"
				placeholder="1234AA"
				v-model="question.Value.UserValue"
			/>
			<input
				v-else
				@change="emitChange"
				:type="inputType"
				:disabled="question.Value.Disabled"
				:id="question.Key"
				v-model="question.Value.UserValue"
			/>
		</label>
	</div>
</template>

<script>
import { mask } from 'vue-the-mask';
import InfoText from '@/partials/InfoText';
export default {
	components: { InfoText },
	directives: { mask },
	props: ['question'],
	computed: {
		inputType: function () {
			switch (this.question.Value.Type) {
				case 'Email':
					return 'email';
				case 'Number':
					return 'number';
				case 'Phone':
					return 'tel';
				case 'Date':
				case 'Text':
				default:
					return 'text';
			}
		},
	},
	methods: {
		emitChange: function () {
			this.$emit('updatedvalue', {
				update: this.question.Value.RequiresRefresh,
				question: this.question,
			});
		},
	},
};
</script>

<style></style>
